import { ROUTING_SIMULATOR } from "@constants/routing";
import { ROUTING_BENCHMARK } from "@constants/simulatorRouting";
import LayoutSelectors from "@layouts/LayoutSelectors";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import {
  Box,
  Card,
  CardContent,
  Divider,
  Grid,
  SelectChangeEvent,
  ToggleButton,
  ToggleButtonGroup,
  Typography
} from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import KpiScenarioLineChart from "./components/KpiScenarioLineChart";
import KpiTotalScenarioBarChart from "./components/KpiTotalScenarioBarChart";
import MediaMixScenarioPieChart from "./components/MediaMixScenarioPieChart";
import MediaSpendScenarioChart from "./components/MediaSpendScenarioChart";
import MediaSpendVariationChart from "./components/MediaSpendVariationChart";
import ScenarioMediaKpiTable from "./components/ScenarioMediaKpiTable";
import ScenarioSelectors from "./components/ScenarioSelectors";

const ViewBenchmark = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [pageSelected, setPageSelected] = useState("benchmark");

  const [selectedScenario1, setSelectedScenario1] = useState("");
  const [selectedScenario2, setSelectedScenario2] = useState("");

  const handlePageSelectionChange = (
    _: React.MouseEvent<HTMLElement>,
    newChartSelected: string
  ) => {
    setPageSelected(newChartSelected);
  };

  const handleChangeScenario1 = (event: SelectChangeEvent) => {
    const sc1Selected = event.target.value as string;
    setSelectedScenario1(sc1Selected);
  };

  const handleChangeScenario2 = (event: SelectChangeEvent) => {
    const sc2Selected = event.target.value as string;
    setSelectedScenario2(sc2Selected);
  };

  return (
    <LayoutSelectors>
      <Box className="w-full pt-4 pl-8 pr-8" sx={{ height: "100%" }}>
        <Box className="w-full flex pb-4">
          <Typography variant="h6" component="div" sx={{ fontSize: 16 }}>
            {t("navbar.tabs.simulator")}
          </Typography>
          <ArrowForwardIosIcon className="pt-1" />
          <Typography variant="h6" component="div" sx={{ fontSize: 16 }}>
            {t("simulator.pages.benchmark")}
          </Typography>
        </Box>
        <Card className="w-full pl-4 pr-4">
          <CardContent>
            <Box className="w-full flex flex-col">
              <Box className="w-full">
                <ToggleButtonGroup
                  color="primary"
                  value={pageSelected}
                  exclusive
                  onChange={handlePageSelectionChange}
                  aria-label="Pages"
                >
                  <ToggleButton
                    value="scenarios"
                    sx={{ textTransform: "none" }}
                    onClick={() => navigate(ROUTING_SIMULATOR)}
                  >
                    {t("simulator.pages.scenarios")}
                  </ToggleButton>
                  <ToggleButton
                    value="benchmark"
                    sx={{ textTransform: "none" }}
                    onClick={() =>
                      navigate(`${ROUTING_SIMULATOR}${ROUTING_BENCHMARK}`)
                    }
                  >
                    {t("simulator.pages.benchmark")}
                  </ToggleButton>
                </ToggleButtonGroup>
              </Box>
              <Box className="w-full flex flex-col mt-4">
                <Box className="w-full">
                  <Typography variant="h6" component="div" className="pb-4">
                    {t("simulator.benchmark.scenario_selection")}
                  </Typography>
                </Box>
                <ScenarioSelectors
                  selectedScenario1={selectedScenario1}
                  selectedScenario2={selectedScenario2}
                  handleChangeScenario1={handleChangeScenario1}
                  handleChangeScenario2={handleChangeScenario2}
                />
                <ScenarioMediaKpiTable
                  scenario1Id={selectedScenario1}
                  scenario2Id={selectedScenario2}
                />
                <Divider className="pt-4" />
                <Grid container justifyContent="center">
                  <Grid
                    size={{ xs: 12, sm: 12, md: 6 }}
                    sx={{ justifyContent: "center" }}
                  >
                    <KpiTotalScenarioBarChart
                      scenario1Id={selectedScenario1}
                      scenario2Id={selectedScenario2}
                    />
                  </Grid>
                  <Grid
                    size={{ xs: 12, sm: 12, md: 6 }}
                    sx={{ justifyContent: "center" }}
                  >
                    <MediaSpendScenarioChart
                      scenario1Id={selectedScenario1}
                      scenario2Id={selectedScenario2}
                    />
                  </Grid>
                </Grid>
                <Divider className="pt-2" />
                <Grid container justifyContent="center">
                  <Grid
                    size={{ xs: 12, sm: 12, md: 6 }}
                    sx={{ justifyContent: "center", width: "100%" }}
                  >
                    <MediaMixScenarioPieChart scenarioId={selectedScenario1} />
                  </Grid>
                  <Grid
                    size={{ xs: 12, sm: 12, md: 6 }}
                    sx={{ justifyContent: "center", width: "100%" }}
                  >
                    <MediaMixScenarioPieChart scenarioId={selectedScenario2} />
                  </Grid>
                </Grid>
                <Divider />

                <Grid container justifyContent="center">
                  <Grid
                    size={{ xs: 12, sm: 12, md: 6 }}
                    sx={{ justifyContent: "center" }}
                  >
                    <KpiScenarioLineChart
                      scenario1Id={selectedScenario1}
                      scenario2Id={selectedScenario2}
                    />
                  </Grid>
                  <Grid
                    size={{ xs: 12, sm: 12, md: 6 }}
                    sx={{ justifyContent: "center" }}
                  >
                    <MediaSpendVariationChart
                      scenario1Id={selectedScenario1}
                      scenario2Id={selectedScenario2}
                    />
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </LayoutSelectors>
  );
};

export default ViewBenchmark;
